export default function where(array, predicate) {
    return array.filter(predicate);
}
